/* Bayline Vintage · interactielaag
   Alles hier is verrijking: zonder JavaScript werken menu (links),
   filters (links), zoeken (formulier) en winkelwagen (formulieren) gewoon
   via volledige paginaladingen. */
(() => {
  'use strict';

  const config = (() => {
    const el = document.getElementById('bayline-config');
    try {
      return el ? JSON.parse(el.textContent) : {};
    } catch {
      return {};
    }
  })();

  const geldFormaat = new Intl.NumberFormat('nl-NL', {
    style: 'currency',
    currency: config.valuta || 'EUR',
  });
  const geld = (centen) => geldFormaat.format(centen / 100);

  /* ── Kleine hulpjes ──────────────────────────────────────────── */
  const $ = (sel, wortel = document) => wortel.querySelector(sel);
  const $$ = (sel, wortel = document) => [...wortel.querySelectorAll(sel)];

  const aankondiger = $('#aankondiger');
  function kondigAan(tekst) {
    if (!aankondiger) return;
    aankondiger.textContent = '';
    requestAnimationFrame(() => {
      aankondiger.textContent = tekst;
    });
  }

  let meldingTimer;
  function toonMelding(tekst) {
    let el = $('.melding-zweef');
    if (!el) {
      el = document.createElement('div');
      el.className = 'melding-zweef';
      document.body.appendChild(el);
    }
    el.textContent = tekst;
    el.classList.add('open');
    clearTimeout(meldingTimer);
    meldingTimer = setTimeout(() => el.classList.remove('open'), 3200);
    kondigAan(tekst);
  }

  const focusbaar = (wortel) =>
    $$(
      'a[href], button:not([disabled]), input:not([disabled]), select, textarea, [tabindex]:not([tabindex="-1"])',
      wortel,
    ).filter((el) => el.offsetParent !== null);

  /* Houdt de focus binnen een lade zolang die open is. */
  function vangFocus(gebeurtenis, wortel) {
    if (gebeurtenis.key !== 'Tab') return;
    const lijst = focusbaar(wortel);
    if (!lijst.length) return;
    const eerste = lijst[0];
    const laatste = lijst[lijst.length - 1];
    if (gebeurtenis.shiftKey && document.activeElement === eerste) {
      gebeurtenis.preventDefault();
      laatste.focus();
    } else if (!gebeurtenis.shiftKey && document.activeElement === laatste) {
      gebeurtenis.preventDefault();
      eerste.focus();
    }
  }

  /* ── Scherm (achtergrondsluier voor lades) ───────────────────── */
  const scherm = $('.scherm');
  let schermSluit = null;
  function toonScherm(bijSluiten) {
    schermSluit = bijSluiten;
    scherm?.classList.add('open');
    document.body.style.overflow = 'hidden';
  }
  function verbergScherm() {
    scherm?.classList.remove('open');
    document.body.style.overflow = '';
    schermSluit = null;
  }
  scherm?.addEventListener('click', () => schermSluit?.());

  /* ── Megamenu (desktop) ──────────────────────────────────────── */
  const menuKnoppen = $$('.hoofdmenu [aria-expanded][data-menu]');
  let openMenu = null;

  function sluitMegamenu(focusTerug = false) {
    if (!openMenu) return;
    const { knop, paneel } = openMenu;
    knop.setAttribute('aria-expanded', 'false');
    paneel.classList.remove('open');
    if (focusTerug) knop.focus();
    openMenu = null;
  }

  menuKnoppen.forEach((knop) => {
    const paneel = document.getElementById(knop.dataset.menu);
    if (!paneel) return;
    knop.addEventListener('click', () => {
      const was = openMenu?.knop === knop;
      sluitMegamenu();
      if (!was) {
        knop.setAttribute('aria-expanded', 'true');
        paneel.classList.add('open');
        openMenu = { knop, paneel };
      }
    });
  });

  document.addEventListener('click', (e) => {
    if (openMenu && !openMenu.paneel.contains(e.target) && !openMenu.knop.contains(e.target)) {
      sluitMegamenu();
    }
  });

  /* ── Mobiel menu ─────────────────────────────────────────────── */
  const menulade = $('.menulade');
  const menuOpenKnop = $('.menuknop');
  let menuladeOpen = false;

  function openMenulade() {
    if (!menulade) return;
    menulade.classList.add('open');
    menuladeOpen = true;
    toonScherm(sluitMenulade);
    menulade.querySelector('.sluitknop')?.focus();
  }
  function sluitMenulade() {
    if (!menulade || !menuladeOpen) return;
    menulade.classList.remove('open');
    menuladeOpen = false;
    verbergScherm();
    menuOpenKnop?.focus();
  }
  menuOpenKnop?.addEventListener('click', openMenulade);
  menulade?.querySelector('.sluitknop')?.addEventListener('click', sluitMenulade);
  menulade?.addEventListener('keydown', (e) => vangFocus(e, menulade));

  /* ── Zoeklaag met suggesties ─────────────────────────────────── */
  const zoeklaag = $('.zoeklaag');
  const zoekveld = zoeklaag?.querySelector('input[type="search"]');
  const zoekuitslag = zoeklaag?.querySelector('.zoekuitslag');
  let zoeklaagOpen = false;
  let laatsteZoekKnop = null;
  let zoekTimer;
  let zoekVolgnummer = 0;

  function openZoeklaag(knop) {
    if (!zoeklaag) return;
    laatsteZoekKnop = knop;
    zoeklaag.classList.add('open');
    zoeklaagOpen = true;
    document.body.style.overflow = 'hidden';
    zoekveld?.focus();
  }
  function sluitZoeklaag() {
    if (!zoeklaag || !zoeklaagOpen) return;
    zoeklaag.classList.remove('open');
    zoeklaagOpen = false;
    document.body.style.overflow = '';
    laatsteZoekKnop?.focus();
  }
  $$('.zoekknop').forEach((knop) =>
    knop.addEventListener('click', (e) => {
      e.preventDefault();
      openZoeklaag(knop);
    }),
  );
  zoeklaag?.addEventListener('click', (e) => {
    if (!$('.paneel', zoeklaag).contains(e.target)) sluitZoeklaag();
  });
  zoeklaag?.addEventListener('keydown', (e) => vangFocus(e, zoeklaag));

  function toonZoekuitslag(html) {
    if (zoekuitslag) zoekuitslag.innerHTML = html;
  }

  async function zoekSuggesties(term) {
    const dit = ++zoekVolgnummer;
    const url =
      `${config.zoekpad || '/search'}/suggest.json?q=${encodeURIComponent(term)}` +
      '&resources[type]=product&resources[limit]=6&resources[options][fields]=title,product_type,variants.title,vendor';
    try {
      const antwoord = await fetch(url);
      const data = await antwoord.json();
      if (dit !== zoekVolgnummer || !zoeklaagOpen) return;
      const producten = data?.resources?.results?.products ?? [];
      if (!producten.length) {
        toonZoekuitslag(`<p class="leeg">Niets gevonden voor &bdquo;${term.replace(/[<>&]/g, '')}&rdquo;. Probeer een merk, soort of maat.</p>`);
        kondigAan('Geen resultaten');
        return;
      }
      const regels = producten
        .map((p) => {
          const beeld = p.featured_image?.url
            ? `<span class="foto"><img src="${p.featured_image.url}&width=96" alt="" width="48" height="64"></span>`
            : '<span class="foto"></span>';
          return `<a href="${p.url}">
            ${beeld}
            <span class="naam">${p.title}<small>${p.vendor ?? ''}</small></span>
            <span class="prijs">${p.price ? geld(Math.round(parseFloat(p.price) * 100)) : ''}</span>
          </a>`;
        })
        .join('');
      toonZoekuitslag(
        `<p class="kopje">Producten</p>${regels}
         <a class="alles" href="${config.zoekpad || '/search'}?q=${encodeURIComponent(term)}">Alle resultaten voor &bdquo;${term.replace(/[<>&]/g, '')}&rdquo;</a>`,
      );
      kondigAan(`${producten.length} suggesties`);
    } catch {
      /* Bij een netwerkfout doet het formulier zijn gewone werk. */
    }
  }

  zoekveld?.addEventListener('input', () => {
    clearTimeout(zoekTimer);
    const term = zoekveld.value.trim();
    if (term.length < 2) {
      toonZoekuitslag('');
      return;
    }
    zoekTimer = setTimeout(() => zoekSuggesties(term), 220);
  });

  /* Pijltjes door de suggesties heen. */
  zoekveld?.addEventListener('keydown', (e) => {
    if (e.key !== 'ArrowDown' && e.key !== 'ArrowUp') return;
    const links = $$('.zoekuitslag a', zoeklaag);
    if (!links.length) return;
    e.preventDefault();
    const huidig = links.findIndex((l) => l.classList.contains('gekozen'));
    const volgend = e.key === 'ArrowDown' ? Math.min(huidig + 1, links.length - 1) : Math.max(huidig - 1, 0);
    links.forEach((l) => l.classList.remove('gekozen'));
    links[volgend].classList.add('gekozen');
    links[volgend].focus();
  });
  zoekuitslag?.addEventListener('keydown', (e) => {
    if (e.key === 'ArrowDown' || e.key === 'ArrowUp') {
      const links = $$('a', zoekuitslag);
      const huidig = links.indexOf(document.activeElement);
      if (huidig === -1) return;
      e.preventDefault();
      const volgend = e.key === 'ArrowDown' ? Math.min(huidig + 1, links.length - 1) : huidig - 1;
      if (volgend < 0) zoekveld?.focus();
      else links[volgend].focus();
    }
  });

  /* ── Winkelwagenlade ─────────────────────────────────────────── */
  const winkellade = $('.winkellade');
  const ladeItems = winkellade?.querySelector('.items');
  const ladeVoet = winkellade?.querySelector('.ladevoet');
  const ladeTitel = winkellade?.querySelector('.ladekop h2');
  let winkelladeOpen = false;
  let laatsteTasKnop = null;

  function zetTeller(aantal) {
    $$('.tasknop .teller').forEach((t) => {
      t.textContent = aantal > 0 ? String(aantal) : '';
    });
  }

  function bouwLade(wagen) {
    if (!ladeItems || !ladeVoet) return;
    if (ladeTitel) ladeTitel.textContent = `Winkelwagen (${wagen.item_count})`;
    if (!wagen.items.length) {
      ladeItems.innerHTML = `
        <div class="leeg">
          <p>Je winkelwagen is leeg.</p>
          <a class="knop primair" href="${config.nieuwBinnenPad || '/collections/nieuw-binnen'}">Bekijk nieuw binnen</a>
        </div>`;
      ladeVoet.innerHTML = '';
      return;
    }
    ladeItems.innerHTML = wagen.items
      .map(
        (item) => `
        <div class="laderegel" data-sleutel="${item.key}">
          <a class="foto" href="${item.url}">
            <img src="${item.image ? item.image.replace(/(\.[a-z]+)(\?|$)/, '_180x240$1$2') : ''}" alt="" width="88" height="117" loading="lazy">
          </a>
          <div>
            <a class="naam" href="${item.url}">${item.product_title}</a>
            ${item.variant_title && item.variant_title !== 'Default Title' ? `<div class="meta">Maat ${item.variant_title}</div>` : ''}
            <div class="rij">
              <span class="prijs">${geld(item.final_line_price)}</span>
              <button class="weghalen" type="button" data-weghalen="${item.key}">Weghalen</button>
            </div>
          </div>
        </div>`,
      )
      .join('');
    ladeVoet.innerHTML = `
      <div class="rij"><span>Subtotaal</span><b>${geld(wagen.total_price)}</b></div>
      <p class="toel">Verzendkosten worden bij het afrekenen berekend. Verzending binnen 24 uur.</p>
      <a class="knop primair breed" href="${config.afrekenPad || '/checkout'}">Afrekenen</a>`;
  }

  async function haalWagen() {
    const antwoord = await fetch('/cart.js');
    return antwoord.json();
  }

  async function openWinkellade(knop) {
    if (!winkellade) return;
    laatsteTasKnop = knop ?? null;
    const wagen = await haalWagen();
    bouwLade(wagen);
    zetTeller(wagen.item_count);
    winkellade.classList.add('open');
    winkelladeOpen = true;
    toonScherm(sluitWinkellade);
    winkellade.querySelector('.sluitknop')?.focus();
  }
  function sluitWinkellade() {
    if (!winkellade || !winkelladeOpen) return;
    winkellade.classList.remove('open');
    winkelladeOpen = false;
    verbergScherm();
    laatsteTasKnop?.focus();
  }
  $$('.tasknop').forEach((knop) =>
    knop.addEventListener('click', (e) => {
      e.preventDefault();
      openWinkellade(knop);
    }),
  );
  winkellade?.querySelector('.sluitknop')?.addEventListener('click', sluitWinkellade);
  winkellade?.addEventListener('keydown', (e) => vangFocus(e, winkellade));

  winkellade?.addEventListener('click', async (e) => {
    const knop = e.target.closest('[data-weghalen]');
    if (!knop) return;
    knop.disabled = true;
    const antwoord = await fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: knop.dataset.weghalen, quantity: 0 }),
    });
    const wagen = await antwoord.json();
    bouwLade(wagen);
    zetTeller(wagen.item_count);
    kondigAan('Artikel weggehaald uit de winkelwagen');
    winkellade.querySelector('.sluitknop')?.focus();
  });

  /* Toevoegen zonder de pagina te verliezen. */
  const productFormulier = $('form[data-productformulier]');
  productFormulier?.addEventListener('submit', async (e) => {
    e.preventDefault();
    const knop = productFormulier.querySelector('[name="add"]');
    if (knop) knop.disabled = true;
    try {
      const antwoord = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({
          items: [{ id: Number(productFormulier.querySelector('[name="id"]').value), quantity: 1 }],
        }),
      });
      if (!antwoord.ok) {
        const fout = await antwoord.json().catch(() => ({}));
        toonMelding(fout.description || 'Toevoegen lukte niet. Probeer het opnieuw.');
        return;
      }
      await openWinkellade(knop);
      kondigAan('Toegevoegd aan de winkelwagen');
    } catch {
      productFormulier.submit();
    } finally {
      if (knop) knop.disabled = false;
    }
  });

  /* Winkelwagenpagina: weghalen zonder herladen. */
  $$('[data-wagen-weghalen]').forEach((knop) =>
    knop.addEventListener('click', async (e) => {
      e.preventDefault();
      knop.disabled = true;
      const antwoord = await fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: knop.dataset.wagenWeghalen, quantity: 0 }),
      });
      const wagen = await antwoord.json();
      zetTeller(wagen.item_count);
      window.location.reload();
    }),
  );

  /* ── Collectie: filteren en sorteren zonder paginasprong ─────── */
  const collectie = $('[data-collectie]');
  if (collectie) {
    const sectieId = collectie.dataset.sectie;

    async function vernieuwCollectie(url, focusDoel) {
      collectie.setAttribute('aria-busy', 'true');
      try {
        const haalUrl = new URL(url, window.location.origin);
        haalUrl.searchParams.set('section_id', sectieId);
        const antwoord = await fetch(haalUrl);
        const html = await antwoord.text();
        const nieuw = new DOMParser().parseFromString(html, 'text/html').querySelector('[data-collectie]');
        if (!nieuw) {
          window.location.href = url;
          return;
        }
        collectie.replaceWith(nieuw);
        history.pushState({}, '', url);
        koppelCollectie();
        const telling = $('[data-telling]');
        if (telling) kondigAan(telling.textContent.trim());
        if (focusDoel) $(`[data-focus="${focusDoel}"]`)?.focus();
      } catch {
        window.location.href = url;
      }
    }

    function koppelCollectie() {
      const blok = $('[data-collectie]');
      if (!blok) return;

      $$('.filterpaneel a[data-filter]', blok).forEach((schakel) =>
        schakel.addEventListener('click', (e) => {
          e.preventDefault();
          vernieuwCollectie(schakel.getAttribute('href'), schakel.dataset.filter);
        }),
      );
      $$('.actieve-filters a[data-filter]', blok).forEach((schakel) =>
        schakel.addEventListener('click', (e) => {
          e.preventDefault();
          vernieuwCollectie(schakel.getAttribute('href'));
        }),
      );
      const sorteer = $('.sorteer select', blok);
      sorteer?.addEventListener('change', () => {
        const url = new URL(window.location.href);
        url.searchParams.set('sort_by', sorteer.value);
        url.searchParams.delete('page');
        vernieuwCollectie(url.pathname + url.search, 'sorteer');
      });

      /* Eén filterlade tegelijk open; Escape sluit en zet de focus terug. */
      const groepen = $$('.filtergroep', blok);
      groepen.forEach((groep) => {
        groep.addEventListener('toggle', () => {
          if (groep.open) groepen.forEach((ander) => ander !== groep && (ander.open = false));
        });
      });
      document.addEventListener('click', (e) => {
        groepen.forEach((groep) => {
          if (groep.open && !groep.contains(e.target)) groep.open = false;
        });
      });
    }

    koppelCollectie();
    window.addEventListener('popstate', () => window.location.reload());
  }

  /* ── Galerij: lichtbak ───────────────────────────────────────── */
  const lichtbak = $('.lichtbak');
  if (lichtbak) {
    const beeld = lichtbak.querySelector('img');
    const bijschrift = lichtbak.querySelector('.bijschrift');
    const bronnen = $$('.galerij .zoomknop').map((knop) => ({
      groot: knop.dataset.groot,
      alt: knop.dataset.alt || '',
      tekst: knop.dataset.bijschrift || '',
    }));
    let huidig = 0;

    function toonBeeld(index) {
      huidig = (index + bronnen.length) % bronnen.length;
      const bron = bronnen[huidig];
      beeld.src = bron.groot;
      beeld.alt = bron.alt;
      if (bijschrift) {
        bijschrift.textContent = bron.tekst;
        bijschrift.hidden = !bron.tekst;
      }
    }

    $$('.galerij .zoomknop').forEach((knop, i) =>
      knop.addEventListener('click', () => {
        toonBeeld(i);
        lichtbak.showModal();
      }),
    );
    lichtbak.querySelector('.sluitknop')?.addEventListener('click', () => lichtbak.close());
    lichtbak.querySelector('.stap.terug')?.addEventListener('click', () => toonBeeld(huidig - 1));
    lichtbak.querySelector('.stap.verder')?.addEventListener('click', () => toonBeeld(huidig + 1));
    lichtbak.addEventListener('keydown', (e) => {
      if (e.key === 'ArrowLeft') toonBeeld(huidig - 1);
      if (e.key === 'ArrowRight') toonBeeld(huidig + 1);
    });
    lichtbak.addEventListener('click', (e) => {
      if (e.target === lichtbak) lichtbak.close();
    });
  }

  /* ── Binnenkomst bij scrollen: opacity en transform, eenmalig ── */
  const beweegOk = window.matchMedia('(prefers-reduced-motion: no-preference)').matches;
  if (beweegOk && 'IntersectionObserver' in window) {
    const kijker = new IntersectionObserver(
      (items) => {
        items.forEach((item) => {
          if (item.isIntersecting) {
            item.target.classList.add('zichtbaar');
            kijker.unobserve(item.target);
          }
        });
      },
      { rootMargin: '0px 0px -8% 0px', threshold: 0.1 },
    );
    $$('.verschijnt').forEach((el) => kijker.observe(el));
  } else {
    $$('.verschijnt').forEach((el) => el.classList.add('zichtbaar'));
  }

  /* ── Escape sluit wat open is, in volgorde van diepte ────────── */
  document.addEventListener('keydown', (e) => {
    if (e.key !== 'Escape') return;
    if (zoeklaagOpen) sluitZoeklaag();
    else if (winkelladeOpen) sluitWinkellade();
    else if (menuladeOpen) sluitMenulade();
    else if (openMenu) sluitMegamenu(true);
  });
})();
